// Bilingual dictionary ES / RO for Marcel & Aida wedding
export const translations = {
  es: {
    nav: { home: "Inicio", details: "Detalles", rsvp: "Confirmar" },
    hero: {
      label: "Nos casamos",
      and: "&",
      date: "04 · Octubre · 2026",
      dateLong: "Domingo, 4 de Octubre de 2026",
      subtitle: "Masia La Torre del Gall · Penedès",
    },
    invitation: {
      label: "La invitación",
      title: "Un día para recordar",
      body:
        "Con la ilusión de celebrar este momento tan especial, queremos compartir con vosotros el día más importante de nuestras vidas.\n\nPorque cada historia merece un capítulo inolvidable, y queremos que forméis parte del nuestro.",
    },
    verse: {
      label: "1 Corintios 13:4-7",
      text:
        "El amor es paciente, es bondadoso. El amor no es envidioso ni jactancioso ni orgulloso. No se comporta con rudeza, no es egoísta, no se enoja fácilmente, no guarda rencor. El amor no se deleita en la maldad, sino que se regocija con la verdad. Todo lo disculpa, todo lo cree, todo lo espera, todo lo soporta.",
    },
    countdown: {
      label: "Cuenta atrás",
      days: "Días",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos",
      finished: "¡Hoy es el día!",
    },
    details: {
      label: "Cuándo y dónde",
      ceremonyTitle: "La Ceremonia",
      time: "13:00 h",
      venue: "Masia La Torre del Gall",
      address: "Carrer la Torre del Gall s/n",
      city: "08798 Sant Cugat Sesgarrigues",
      region: "Alt Penedès · Barcelona",
      openMaps: "Abrir en Google Maps",
    },
    menu: {
      label: "El menú",
      title: "Elige tu plato principal",
      subtitle: "Dos opciones cuidadosamente seleccionadas",
      option1: {
        name: "Lubina",
        desc: "Lubina rellena de setas y puerros, con muselina y calamares con espárragos verdes.",
      },
      option2: {
        name: "Laminado Ibérico",
        desc: "Laminado ibérico relleno de manzana y foie, con parmentier de patata trufada y salsa de foie.",
      },
    },
    rsvp: {
      label: "Confirmación",
      title: "Confirma tu asistencia",
      subtitle: "Por favor, responde antes del 14 de Septiembre de 2026",
      name: "Nombre completo",
      namePh: "Tu nombre y apellidos",
      attending: "¿Asistirás?",
      yes: "Sí, allí estaré",
      no: "No podré asistir",
      menuChoice: "Asigna un menú a cada asistente",
      menuPlaceholder: "Selecciona una opción",
      menuLubina: "Lubina",
      menuIberico: "Laminado Ibérico",
      menuTeen1417: "Menú adolescentes (14 a 17 años)",
      menuChild613: "Menú infantil (6 a 13 años)",
      menuChild25: "Menú infantil (2 a 5 años)",
      assignAll: "Debes asignar un menú a todos los asistentes.",
      remaining: "Sin asignar",
      overAssigned: "Has asignado más menús que asistentes. Ajusta la selección.",
      companions: "Total de asistentes (te incluye a ti)",
      companionsPh: "1",
      allergies: "Alergias o restricciones",
      allergiesPh: "Indica cualquier alergia o intolerancia",
      message: "Mensaje para los novios (opcional)",
      messagePh: "Deja unas palabras…",
      submit: "Enviar confirmación",
      sending: "Enviando…",
      successTitle: "¡Gracias!",
      successYes: "Tu confirmación ha sido enviada. Nos vemos el 4 de Octubre.",
      successNo: "Gracias por avisar. Te echaremos de menos.",
      newResponse: "Enviar otra respuesta",
      errorRequired: "Por favor, completa tu nombre.",
      errorGeneric: "No se pudo enviar. Inténtalo de nuevo.",
    },
    contact: {
      label: "Contacto",
      title: "¿Alguna duda?",
      marcel: "Marcel",
      aida: "Aida",
    },
    footer: {
      with: "Con todo el amor",
      year: "2026",
    },
    admin: {
      title: "Panel de Administración",
      loginTitle: "Acceso privado",
      passwordPlaceholder: "Contraseña",
      enter: "Acceder",
      wrong: "Contraseña incorrecta",
      logout: "Cerrar sesión",
      total: "Total",
      attending: "Asistirán",
      notAttending: "No asistirán",
      lubina: "Lubina",
      iberico: "Ibérico",
      totalGuests: "Invitados totales",
      empty: "Aún no hay confirmaciones",
      name: "Nombre",
      status: "Estado",
      menu: "Menú",
      companionsCol: "Total asist.",
      allergiesCol: "Alergias",
      messageCol: "Mensaje",
      date: "Fecha",
      actions: "Acciones",
      edit: "Editar",
      delete: "Eliminar",
      save: "Guardar",
      cancel: "Cancelar",
      editTitle: "Editar confirmación",
      savedOk: "Cambios guardados",
      deletedOk: "Confirmación eliminada",
      confirmDeleteTitle: "Eliminar confirmación",
      confirmDeleteMsg: "¿Seguro que quieres eliminar la confirmación de",
      downloadCsv: "Descargar CSV",
      csvDownloaded: "CSV descargado",
    },
  },
  ro: {
    nav: { home: "Acasă", details: "Detalii", rsvp: "Confirmă" },
    hero: {
      label: "Ne căsătorim",
      and: "&",
      date: "04 · Octombrie · 2026",
      dateLong: "Duminică, 4 Octombrie 2026",
      subtitle: "Masia La Torre del Gall · Penedès",
    },
    invitation: {
      label: "Invitația",
      title: "O zi de neuitat",
      body:
        "Cu bucuria de a sărbători acest moment atât de special, dorim să împărtășim cu voi cea mai importantă zi din viața noastră.\n\nPentru că fiecare poveste merită un capitol de neuitat, și vrem ca voi să faceți parte din al nostru.",
    },
    verse: {
      label: "1 Corinteni 13:4-7",
      text:
        "Dragostea este îndelung răbdătoare, este plină de bunătate: dragostea nu pizmuiește; dragostea nu se laudă, nu se umflă de mândrie, nu se poartă necuviincios, nu caută folosul său, nu se mânie, nu se gândește la rău, nu se bucură de nelegiuire, ci se bucură de adevăr, acoperă totul, crede totul, nădăjduiește totul, suferă totul.",
    },
    countdown: {
      label: "Numărătoare inversă",
      days: "Zile",
      hours: "Ore",
      minutes: "Minute",
      seconds: "Secunde",
      finished: "Astăzi este ziua!",
    },
    details: {
      label: "Când și unde",
      ceremonyTitle: "Ceremonia",
      time: "ora 13:00",
      venue: "Masia La Torre del Gall",
      address: "Carrer la Torre del Gall s/n",
      city: "08798 Sant Cugat Sesgarrigues",
      region: "Alt Penedès · Barcelona",
      openMaps: "Deschide în Google Maps",
    },
    menu: {
      label: "Meniul",
      title: "Alege felul principal",
      subtitle: "Două opțiuni alese cu grijă",
      option1: {
        name: "Biban de mare",
        desc: "Biban de mare umplut cu ciuperci și praz, cu muselină și calamari cu sparanghel verde.",
      },
      option2: {
        name: "Laminat Iberic",
        desc: "Laminat iberic umplut cu mere și foie gras, cu parmentier de cartofi cu trufe și sos de foie.",
      },
    },
    rsvp: {
      label: "Confirmare",
      title: "Confirmă prezența",
      subtitle: "Te rugăm să răspunzi până la 14 Septembrie 2026",
      name: "Nume complet",
      namePh: "Numele și prenumele tău",
      attending: "Vei participa?",
      yes: "Da, voi fi acolo",
      no: "Nu pot participa",
      menuChoice: "Atribuie un meniu fiecărui participant",
      menuPlaceholder: "Selectează o opțiune",
      menuLubina: "Biban de mare",
      menuIberico: "Laminat Iberic",
      menuTeen1417: "Meniu adolescenți (14 până la 17 ani)",
      menuChild613: "Meniu pentru copii (6 până la 13 ani)",
      menuChild25: "Meniu pentru copii (2 până la 5 ani)",
      assignAll: "Trebuie să atribui un meniu fiecărui participant.",
      remaining: "Neatribuit",
      overAssigned: "Ai atribuit mai multe meniuri decât participanți. Ajustează selecția.",
      companions: "Total participanți (te include și pe tine)",
      companionsPh: "1",
      allergies: "Alergii sau restricții",
      allergiesPh: "Menționează orice alergie sau intoleranță",
      message: "Mesaj pentru miri (opțional)",
      messagePh: "Lasă câteva cuvinte…",
      submit: "Trimite confirmarea",
      sending: "Se trimite…",
      successTitle: "Mulțumim!",
      successYes: "Confirmarea ta a fost trimisă. Ne vedem pe 4 Octombrie.",
      successNo: "Mulțumim că ne-ai anunțat. Ne vei lipsi.",
      newResponse: "Trimite alt răspuns",
      errorRequired: "Te rugăm să completezi numele.",
      errorGeneric: "Nu am putut trimite. Încearcă din nou.",
    },
    contact: {
      label: "Contact",
      title: "Ai vreo întrebare?",
      marcel: "Marcel",
      aida: "Aida",
    },
    footer: {
      with: "Cu toată dragostea",
      year: "2026",
    },
    admin: {
      title: "Panou de Administrare",
      loginTitle: "Acces privat",
      passwordPlaceholder: "Parolă",
      enter: "Intră",
      wrong: "Parolă incorectă",
      logout: "Deconectare",
      total: "Total",
      attending: "Vor participa",
      notAttending: "Nu participă",
      lubina: "Biban",
      iberico: "Iberic",
      totalGuests: "Invitați total",
      empty: "Încă nu există confirmări",
      name: "Nume",
      status: "Status",
      menu: "Meniu",
      companionsCol: "Total invitați",
      allergiesCol: "Alergii",
      messageCol: "Mesaj",
      date: "Data",
      actions: "Acțiuni",
      edit: "Editează",
      delete: "Șterge",
      save: "Salvează",
      cancel: "Anulează",
      editTitle: "Editează confirmarea",
      savedOk: "Modificări salvate",
      deletedOk: "Confirmare ștearsă",
      confirmDeleteTitle: "Șterge confirmarea",
      confirmDeleteMsg: "Sigur vrei să ștergi confirmarea lui",
      downloadCsv: "Descarcă CSV",
      csvDownloaded: "CSV descărcat",
    },
  },
};

export const WEDDING_DATE_ISO = "2026-10-04T13:00:00+02:00";
